export default {
  'profile': 'Профиль',
  'name': 'Имя',
  'refresh': 'Обновить',
  'bill': 'Счет',
  'history': 'История',
  'planing': 'Планирование',
  'newRecord': 'Новая запись',
  'categories': 'Категории',
  'billInCur': 'Счет в валюте',
  'exRate': 'Курс валют',
  'currency': 'Валюта',
  'course': 'Курс',
  'date': 'Дата',
  'recHistory': 'История записей',
  'noRec': 'Записей пока нет',
  'addRec': 'Добавить запись',
  'prev': 'Назад',
  'next': 'Вперед',
  'amount': 'Сумма',
  'type': 'Тип',
  'open': 'Открыть',
  'costsByCat': 'Затраты по категориям',
  'income': 'Доход',
  'outcome': 'Расход',
  'more': 'Подробнее',
  'smthGoneWrong': "Что-то пошло не так",
  'addNewRecord': 'Добавить новую запись',
  'stayed': 'Осталось',
  'limited': 'Излишне потрачены',
  'description': 'Описание',
  'noCategory': 'Категорий пока нет. ',
  'addNewCategory': 'Добавить новую категорию',
  'from': 'из',
  'logout': 'Выйти',
  'chooseCategory': 'Выберите категорию',
  'create': 'Создать',
  'typeAmount': 'Введите сумму',
  'typeDesc': 'Введите описание',
  'valueMin': 'Значение должно быть не меньше',
  'succesRec': 'Запись успешно создана!',
  'notEnoughMoney': 'Нехватает денег на счету!',
  'limit': 'Лимит',
  'typeName': 'Введите название',
  'succesCat': "Категория успешно создана",
  'edit': 'Редактировать',
  'succesCatUpdate': 'Категория успешно обновлена!',
  'detail': "Запись",
  'register': 'Регистрация',
  'login': 'Вход'
}
